module.exports = __webpack_public_path__ + "assets/img/lobby_welcome.d824ab5a.png";